/* global $ */

import moment from 'moment'

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

export default async _this => {
  _this.columns = [
    'time',
    'active',
    'old',
    'client',
    'name',
    'location',
    'remarks',
    'ip',
    'status',
    'model',
    'serialNumber',
    'total',
    'color',
    'black',
    'tonerblack',
    'tonercyan',
    'tonermagenta',
    'toneryellow'
  ]

  const printerData = {}

  _this.$printersLoader = $('#printersLoader')
  _this.$printersLoader.addClass('md-show')

  if (_this.clients.length > 1000) {
    await delay(100)
  }

  for (let client of _this.clients) {
    if (
      client.snapshot.id !== _this.clientSelected &&
      _this.clientSelected !== 'all'
    ) {
      if (_this.clients.length > 1000) {
        continue
      }
    }

    const computer = client.computer

    if (computer && computer.printers) {
      for (let printer of computer.printers) {
        if (printer.macAddress || (printer.parsed && printer.parsed.serialNumber)) {
          const unixTime = moment.unix(printer.time.seconds)
          // duplicated devices at this specific date all across the system
          if (unixTime.year() === 2024 && unixTime.month() === 3 && unixTime.date() === 11) {
            continue
          }
          let active = true
          let old = false
          let name = ''
          let location = ''
          let remarks = ''
          let serialNumber = ''
          const printerId = printer.id
          let printerParsed = printer.parsed
          let model = printerParsed.model
          const originalSerialNumber = printerParsed.serialNumber
          _this.walker(printerParsed, _this.cleanseValue)
          if (originalSerialNumber && originalSerialNumber.toString().length < 20) {
            printerParsed.serialNumber = originalSerialNumber
          }
          if (_this.user.settings && _this.user.settings.printers) {
            const printerSettings = _this.user.settings.printers[printerId]
            if (printerSettings) {
              printerParsed['settings'] = printerSettings
              if (printerSettings.hasOwnProperty('active')) {
                active = printerSettings.active
              }
              if (printerSettings.name) {
                name = printerSettings.name
              }
              if (printerSettings.location) {
                location = printerSettings.location
              }
              if (printerSettings.remarks) {
                remarks = printerSettings.remarks
              }
              if (printerSettings.serialNumber && printerSettings.serialNumber.length > 3) {
                serialNumber = printerSettings.serialNumber
              }
              if (printerSettings.model) {
                model = printerSettings.model
              }
            }
          }
          printerParsed.model = model
          const row = {
            DT_RowId: printerId,
            path: printer.path,
            parsed: printerParsed,
            time: unixTime.unix() * 1000,
            client: client.name,
            active,
            old,
            name,
            location,
            remarks,
            serialNumber
          }

          const serviceData = computer.services.find(
            element => element.snapshot.id === printerId
          )
          row.service = !!(serviceData && serviceData.active)

          if (printerParsed.model) {
            // printerParsed.model = printerParsed.model.replace(/series/i, '').trim();
            if (!printerParsed.manufacturer) {
              let model = printerParsed.model.split(' ')
              printerParsed.manufacturer = model[0]
              model.shift()
              printerParsed.model = model.join(' ')
            }
            if (
              printerParsed.serialNumber &&
              printerParsed.model.indexOf(printerParsed.serialNumber) !== -1
            ) {
              printerParsed.model = printerParsed.model
                .replace(printerParsed.serialNumber, '')
                .trim()
            }
            printerParsed.model = _this.sanitizeName(printerParsed.model)
            printer.manufacturer = printerParsed.manufacturer
            printer.model = printerParsed.model
          }

          if (printerParsed.serialNumber) {
            printerParsed.serialNumber = printerParsed.serialNumber.split(
              '-'
            )[0]
          }

          if (printer.status) {
            row.status = printer.status
            if (typeof printer.status === 'object') { row.status.time = printer.time }
          }

          if (computer.printerAlerts) {
            let printerAlert = computer.printerAlerts[printer.ip]
            if (printerAlert) {
              printerAlert.status.time = printerAlert.time
              if (
                printerAlert.macAddress === printer.macAddress &&
                printerAlert.time.seconds > printer.time.seconds
              ) { row.status = printerAlert.status }
            }
          }

          for (const prop in printerParsed) {
            switch (prop) {
              case 'markerSupplies':
                if (active) {
                  for (const innerProp in printerParsed[prop]) {
                    const supply = printerParsed[prop][innerProp]
                    let column = _this.columnsConnected[supply.name.toLowerCase()]
                      ? _this.columnsConnected[supply.name.toLowerCase()]
                      : supply.name
                    column = column ? column.toLowerCase() : column
                    row[column] = supply.value + '%'
                    if (_this.markerSupplies.indexOf(column) === -1) { _this.markerSupplies.push(column) }
                    _this.columns.push(column.toLowerCase())
                  }
                }
                break
              case 'mediaInputs':
                if (active) {
                  for (const innerProp in printerParsed[prop]) {
                    const mediaInput = printerParsed[prop][innerProp]
                    let column = _this.columnsConnected[mediaInput.name ? mediaInput.name.toLowerCase() : mediaInput.name]
                      ? _this.columnsConnected[mediaInput.name.toLowerCase() ? mediaInput.name.toLowerCase() : mediaInput.name]
                      : mediaInput.name
                    column = column ? column.toLowerCase() : column
                    if (
                      column &&
                      (mediaInput.level || mediaInput.level === 0)
                    ) {
                      row[column] = mediaInput.level + '%'
                      if (_this.mediaInputs.indexOf(column) === -1) {
                        _this.mediaInputs.push(column)
                      }
                      _this.columns.push(column.toLowerCase())
                    }
                  }
                }
                break
              case 'counters':
                if (active) {
                  for (let innerProp in printerParsed[prop]) {
                    if (innerProp !== 'tree') {
                      const val = printerParsed[prop][innerProp]
                      innerProp = innerProp.toLowerCase()
                      if (val) {
                        row[innerProp] = val.toLocaleString('en')
                        _this.columns.push(innerProp.toLowerCase())
                      }
                    }
                  }
                }
                break
              case 'ip':
                // ${
                //   printerParsed.connectionType === "usb"
                //     ? '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-usb-symbol" viewBox="0 0 16 16"><title>USB</title><path d="m7.792.312-1.533 2.3A.25.25 0 0 0 6.467 3H7.5v7.319a2.5 2.5 0 0 0-.515-.298L5.909 9.56A1.5 1.5 0 0 1 5 8.18v-.266a1.5 1.5 0 1 0-1 0v.266a2.5 2.5 0 0 0 1.515 2.298l1.076.461a1.5 1.5 0 0 1 .888 1.129 2.001 2.001 0 1 0 1.021-.006v-.902a1.5 1.5 0 0 1 .756-1.303l1.484-.848A2.5 2.5 0 0 0 11.995 7h.755a.25.25 0 0 0 .25-.25v-2.5a.25.25 0 0 0-.25-.25h-2.5a.25.25 0 0 0-.25.25v2.5c0 .138.112.25.25.25h.741a1.5 1.5 0 0 1-.747 1.142L8.76 8.99a2.584 2.584 0 0 0-.26.17V3h1.033a.25.25 0 0 0 .208-.389L8.208.312a.25.25 0 0 0-.416 0Z"/></svg>'
                //     : '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wifi" viewBox="0 0 16 16"><title>Network</title><path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.444 12.444 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.518.518 0 0 0 .668.05A11.448 11.448 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049z"/> <path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.455 9.455 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065zm-2.183 2.183c.226-.226.185-.605-.1-.75A6.473 6.473 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.478 5.478 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091l.016-.015zM9.06 12.44c.196-.196.198-.52-.04-.66A1.99 1.99 0 0 0 8 11.5a1.99 1.99 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z"/></svg>'
                // }&nbsp;&nbsp;
                row[prop] = `${printerParsed[prop]}`
                _this.columns.push(prop)
                break
              case 'connectionType':
                break
              default:
                if (typeof printerParsed[prop] !== 'object') {
                  switch (prop) {
                    case 'colorful':
                      row[prop] = _this.t(printerParsed[prop])
                      break
                    case 'serialNumber':
                      if (!row[prop]) row[prop] = printerParsed[prop]
                      break
                    default:
                      row[prop] = printerParsed[prop]
                  }
                  _this.columns.push(prop)
                }
            }
          }
          printerData[`${computer.snapshot.id}/${printerId}`] = row
          _this.data.push(row)
        }
      }
    }
  }

  let visibleColumns = [
    'time',
    'model',
    'serialNumber',
    'ip',
    'total',
    'color',
    'black',
    'tonerBlack',
    'tonerCyan',
    'tonerMagenta',
    'tonerYellow',
    'tray1',
    'tray2',
    'status'
  ]
  let enabledStateSave = true
  if (_this.ref && _this.ref.id && _this.ref.id.startsWith('DfPTlAKtKAQ')) {
    enabledStateSave = false
    visibleColumns = [
      'time',
      'model',
      'serialNumber',
      'ip',
      'total',
      'color',
      'black',
      'total2',
      'color2',
      'black2'
    ]
  }
  if (_this.ref && _this.ref.id && (_this.ref.id.startsWith('TMCpI3G4DXS') || _this.ref.id.startsWith('RzAhicAzUsf'))) {
    enabledStateSave = false
    visibleColumns = [
      'time',
      'model',
      'serialNumber',
      'ip',
      'total',
      'color',
      'black',
      'total2',
      'color2',
      'black2'
    ]
  }
  if (_this.ref && _this.ref.id && _this.ref.id.startsWith('h3aIzds0nTU')) {
    enabledStateSave = false
    visibleColumns = [
      'time',
      'model',
      'serialNumber',
      'ip',
      'total',
      'color',
      'black',
      'tonerblack',
      'wastetoner',
      'fuser'
    ]
  }
  if (_this.ref && _this.ref.id && _this.ref.id.startsWith('UMq8GfwAaEf')) {
    enabledStateSave = false
    visibleColumns = [
      'time',
      'name',
      'location',
      'serialNumber',
      'model',
      'total',
      'black',
      'color',
      'total2',
      'black2',
      'color2'
    ]
  }
  if (!_this.desktop) visibleColumns.splice(1, 0, 'client')
  $.each(_this.unique(_this.columns), function (index, column) {
    let uniqueColumn = { data: column }
    let visible = false
    if (visibleColumns.includes(column)) visible = true
    switch (column) {
      case 'status':
        uniqueColumn['className'] = 'status'
        uniqueColumn['defaultContent'] = _this.t('ok')
        uniqueColumn['render'] = function (data, type, row, meta) {
          if (typeof data === 'object') {
            let title = ''
            if (data.time != null) {
              title = moment.unix(data.time.seconds).fromNow()
            }

            let displayCode
            let descriptionHidden = false
            if (data.code != null) {
              if (
                [
                  'subunitPowerSaver',
                  'powerDown',
                  'markerFuserUnderTemperature'
                ].includes(data.code) ||
                (data.description && data.description.toLowerCase() === 'sleep')
              ) {
                data.severity = 'ok'
                descriptionHidden = true
              }
              const result = data.code.replace(/([A-Z])/g, ' $1')
              displayCode = result.charAt(0).toUpperCase() + result.slice(1)
              if (title !== '') {
                title = title + ': '
              }
              title = title + displayCode
            }

            if (data.description != null) {
              if (title !== '') {
                title = title + ': '
              }
              title = title + data.description
            }

            const display = `${_this.t(data.severity)}${
              displayCode && !descriptionHidden ? ` - ${displayCode}` : ''
            }`
            return `<span class="status ${data.severity}" title="${title}">${display}</span>`
          } else {
            return data
          }
        }
        break
      case 'time':
        uniqueColumn['name'] = 'time'
        uniqueColumn['title'] = 'last scan'
        uniqueColumn['className'] = 'defaultOrderBy'
        uniqueColumn['render'] = (data, type, row, meta) => {
          if (type !== 'sort') {
            return data ? moment(data).format('L HH:mm') : ''
          }
          return data || ''
        }
        break
      case 'active':
        uniqueColumn['name'] = 'active'
        break
      case 'old':
        uniqueColumn['name'] = 'old'
        break
      case 'name':
        uniqueColumn['name'] = 'name'
        break
      case 'location':
        uniqueColumn['location'] = 'location'
        break
      case 'remarks':
        uniqueColumn['remarks'] = 'remarks'
        uniqueColumn['render'] = (data, type, row, meta) =>
          data.replace(/\n/gm, '\r\n<br />')
        break
      case 'model':
        uniqueColumn['render'] = (data, type, row, meta) =>
          `${row.manufacturer || ''} ${row.model || ''}`
        break
    }
    if (_this.markerSupplies.indexOf(column) !== -1) {
      // uniqueColumn["type"] = "numericnonempty";
      uniqueColumn['render'] = (data, type, row, meta) => {
        if (!data) data = ''
        else {
          try {
            if (/^\d+(\.\d+)?%$/.test(data)) {
              const strippedNumber = Number(data.replace('%', ''))
              // console.log(strippedNumber);
              if (type === 'sort') {
                if (strippedNumber === '') return -1
                return strippedNumber
              }
              if (strippedNumber <= 15) {
                return `<span style="color:red;">${data}</span>`
              }
            }
          } catch (e) {}
        }
        return `<span>${data}</span>`
      }
    }
    if (!uniqueColumn['title']) uniqueColumn['title'] = _this.t(column)
    uniqueColumn['visible'] = visible
    _this.uniqueColumns.push(uniqueColumn)
  })

  const currentTime = new Date().getTime()
  let {
    /* columns, */
    options
  } = _this.createTableProperties(_this)
  options = $.extend(true, options, {
    stateSave: enabledStateSave,
    initComplete: settings => {
      setTimeout(id => {
        _this.table
          .column('active:name')
          .search('true')
          .draw(false)
        // const printer = _this.getUrlParameter('printer')
        // if (printer) {
        //   const $printerModal = $('#printer-modal')
        //   _this.openedPrinter = defaultOpenedPrinter
        //   _this.openedPrinter = _this.table.row('#' + printer).data()
        //   $printerModal.modal('show')
        // }
      }, 10)
    },
    rowCallback: function (row, data) {
      const { time: rowTime } = data
      const timeDiff = currentTime - rowTime
      const hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60))
      if (hoursDiff > 24) {
        $(row).addClass('not-today')
      }
    }
  })
  console.log('options', options)
  window.printersTable = _this.table = $(_this.$el)
    .find('table')
    .DataTable(options)
  let fields, ajax, editor
  fields = [
    {
      label: _this.t('Active'),
      name: 'active',
      data: 'active',
      type: 'yesno',
      def: true
    },
    {
      label: _this.t('Serial Number'),
      fieldInfo: 'Leave default or empty for original Serial Number',
      name: 'serialNumber',
      data: 'serialNumber',
      def: ''
    },
    {
      label: _this.t('Model'),
      fieldInfo: 'Leave default or empty for original Model',
      name: 'model',
      data: 'model',
      def: ''
    },
    {
      label: _this.t('Name'),
      name: 'name',
      data: 'name',
      def: ''
    },
    {
      label: _this.t('Location'),
      name: 'location',
      data: 'location',
      def: ''
    },
    {
      label: _this.t('Remarks'),
      name: 'remarks',
      data: 'remarks',
      type: 'textarea',
      def: ''
    },
    {
      label: _this.t('Cloud Print'),
      name: 'service',
      data: 'service',
      type: 'yesno',
      def: false
    }
  ]

  ajax = (method, url, d, success, error) => {
    let output = { data: [] }
    switch (d.action) {
      case 'edit':
        let printers = {}
        Object.keys(d.data).forEach(id => {
          let value = d.data[id]
          value.DT_RowId = id
          const rowData = _this.table.row('#' + id).data()
          const data = $.extend({}, rowData, value)
          const printerRef = _this.$store.state.db.doc(data.path)
          if (printerData[`${printerRef.parent.parent.id}/${rowData.printerId}`]) {
            if (!data.serialNumber) {
              data.serialNumber =
                printerData[`${printerRef.parent.parent.id}/${rowData.printerId}`].serialNumber
            }
            if (!data.model) {
              data.model =
                printerData[`${printerRef.parent.parent.id}/${rowData.printerId}`].model
            }
          }
          output.data.push(data)
          const serviceRef = printerRef.parent.parent
            .collection('service')
            .doc(id)
          console.log(serviceRef.path)
          if (
            value.service !== undefined &&
            rowData.service !== value.service
          ) {
            let options = { active: !!value.service }
            if (value.service) {
              options.qrcode = Math.random()
                .toString(36)
                .substr(2, 6)
              _this.$store.state.db
                .collection('qrcodes')
                .doc(options.qrcode)
                .set({ printer: printerRef })
              serviceRef.set(options, { merge: true })
            } else {
              options.qrcode = null
              serviceRef.get().then(snapshot => {
                const qrcode = snapshot.data().qrcode
                if (qrcode) {
                  _this.$store.state.db
                    .collection('qrcodes')
                    .doc(qrcode)
                    .delete()
                }
                serviceRef.delete()
              })
            }
            delete value.service
          }
          delete value.DT_RowId
          // console.log(value);
          printers[id] = value
        })
        _this.ref
          .set(
            {
              settings: {
                printers
              }
            },
            { merge: true }
          )
          .then(() => {
            try { _this.table.rows().deselect() } catch (e) {}
            try { if (editor) editor.close() } catch (e) {}
            _this.$store.dispatch('user/set_property', { property: 'reload', value: true })
          })
          .catch(function(e) {
            error(e)
          })
        break
    }
  }
  editor = _this.createEditor(_this, fields, ajax)
  let buttons1 = []
  let buttons2 = []
  buttons1 = [
    {
      extend: 'edit',
      editor: editor,
      text: '<span class="icon s7-pen"></span>',
      titleAttr: _this.t('Edit')
    }
  ]
  _this.createButtons(_this, buttons1, buttons2)

  const tableId = window.printersTable
    .containers()[0]
    .getAttribute('id')
    .split('_')[2]

  $(`<div class="switch-buttons">
        <span>Active: </span>
        <div class="switch-button switch-button-yesno">
            <input type="checkbox" checked="" name="activePrinterSwitch" id="activePrinterSwitch">
            <span>
                <label for="activePrinterSwitch"></label>
            </span>
        </div>
    </div>`).prependTo(
    `#DataTables_Table_${tableId}_wrapper .row.mai-datatable-footer .col-md-5`
  )
  $('#activePrinterSwitch').on('change', () =>
    _this.table
      .column('active:name')
      .search($('#activePrinterSwitch').is(':checked'))
      .draw(false)
  )

  $(`<div class="dt-buttons btn-group dt-header-buttons right">
      <div id="printers-date-range" class="date-range" style="background: #fff; cursor: pointer; border: 1px solid #ccc; padding: 0 10px; padding-right: 6px;">
        <i class="icon s7-date"></i>&nbsp;
        <span></span> <i class="fa fa-caret-down"></i>
      </div>
    </div>`).prependTo(`#DataTables_Table_${tableId}_wrapper`)

  const printersDateRangeCb = (start, end) =>
    $('#printers-date-range span').html(
      start.format('ll') + ' - ' + end.format('ll')
    )

  $('#printers-date-range').daterangepicker(
    {
      startDate: _this.startDate,
      endDate: _this.endDate,
      ranges: _this.ranges,
      opens: 'left'
    },
    printersDateRangeCb
  )

  printersDateRangeCb(_this.startDate, _this.endDate)

  const applyDateRange = (startDate, endDate) => {
    _this.table.processing(true)
    $(this).val(startDate.format('ll') + ' to ' + endDate.format('ll'))
    const filteredData = _this.table
      .column('time:name')
      .data()
      .filter(
        value =>
          moment(value).isAfter(moment(startDate).startOf('day')) &&
          moment(value).isBefore(moment(endDate).endOf('day'))
      )
    let val = ''
    for (var count = 0; count < filteredData.length; count++) {
      val += moment(filteredData[count]).format('L HH:mm') + '|'
    }
    val = val.slice(0, -1)
    _this.table
      .column('time:name')
      .search(val ? '^' + val + '$' : '^' + '-' + '$', true, false, true)
      .draw()
    _this.table.processing(false)
    _this.$printersLoader.removeClass('md-show')
  }

  $('#printers-date-range').on('apply.daterangepicker', (event, picker) => {
    event.preventDefault()
    applyDateRange(picker.startDate, picker.endDate)
  })

  applyDateRange(_this.startDate, _this.endDate)
  setTimeout(() => $(window).resize(), 100)
}



// WEBPACK FOOTER //
// ./src/mixins/Printers.js